import React, { useState } from "react";
import { useFormContext } from "react-hook-form";
import MyBox from "../../MyBox";
import { ImageUploader } from "../../../components/ImageUploader";

interface ImageInputProps {
  name: string;                 // form field name
  label?: string;
  resize?: boolean;
}

export function ImageInput({
  name,
  label = "Upload Image",
  resize = false,
}: ImageInputProps) {
  const { setValue, watch } = useFormContext();
  const uploadedUrl = watch(name); // react-hook-form value
  const [preview, setPreview] = useState<string | null>(uploadedUrl ?? null);

  return (
    <MyBox topText={label}>
      <div className="flex flex-col items-center gap-3">
        {/* Existing image (edit mode) */}
        {preview && (
          <img
            src={preview}
            alt="Uploaded"
            className="w-40 h-40 object-cover rounded-xl border shadow"
          />
        )}

        {/* Reusable uploader */}
        <ImageUploader
          resize={resize}
          onUploadComplete={(url) => {
            setValue(name, url, { shouldDirty: true });
            setPreview(url);
          }}
        />
      </div>
    </MyBox>
  );
}